const requiredKeys = ["API_URL", "CDN_URL", "LIFEWAY_ACCOUNT_URL", "LIFEWAY_ACCOUNT_CLIENT_ID", "READER_URL"] as const

type RequiredKey = (typeof requiredKeys)[number]

type Environment = Readonly<Record<RequiredKey, string>> & {
  readonly APP_ENV: string
  /**
   * Where the Digital Library links out to for anything myLifeway still owns —
   * Manage Access today (FINDINGS.md gap 25). Not required: it has a per-env
   * default rather than blocking startup, because nothing in the app depends on
   * it being reachable, only on the link being correct.
   */
  readonly MLC_ORIGIN: string
  /**
   * Where a seat's content is watched and where a simulcast is attended. Same
   * shape as `READER_URL` and optional for the same reason as `MLC_ORIGIN`:
   * nothing in the app depends on them being reachable, only on the link being
   * correct, so a missing one falls back rather than blocking startup.
   *
   * The fallbacks are PROD, which is not an oversight — `/locations` on UAT
   * hands back prod hosts for every seat (see `features/entitlements/accessTarget.ts`),
   * so prod is what commerce itself says. Setting these is how a non-prod
   * environment overrides commerce and gets a link that lands somewhere it can
   * actually sign in.
   */
  readonly PLAYER_URL: string
  readonly LIVE_EVENTS_URL: string
}

const source: Readonly<
  Record<RequiredKey | "APP_ENV" | "MLC_ORIGIN" | "PLAYER_URL" | "LIVE_EVENTS_URL", string | undefined>
> = {
  API_URL: import.meta.env.VITE_API_URL,
  CDN_URL: import.meta.env.VITE_CDN_URL,
  LIFEWAY_ACCOUNT_URL: import.meta.env.VITE_LIFEWAY_ACCOUNT_URL,
  LIFEWAY_ACCOUNT_CLIENT_ID: import.meta.env.VITE_LIFEWAY_ACCOUNT_CLIENT_ID,
  READER_URL: import.meta.env.VITE_READER_URL,
  APP_ENV: import.meta.env.VITE_APP_ENV,
  MLC_ORIGIN: import.meta.env.VITE_MLC_ORIGIN,
  PLAYER_URL: import.meta.env.VITE_PLAYER_URL,
  LIVE_EVENTS_URL: import.meta.env.VITE_LIVE_EVENTS_URL,
}

console.log(source)

export const missingEnvironmentKeys = (): readonly RequiredKey[] => requiredKeys.filter(key => !source[key])

export const ENV: Environment = {
  API_URL: source.API_URL ?? "",
  CDN_URL: source.CDN_URL ?? "",
  LIFEWAY_ACCOUNT_URL: source.LIFEWAY_ACCOUNT_URL ?? "",
  LIFEWAY_ACCOUNT_CLIENT_ID: source.LIFEWAY_ACCOUNT_CLIENT_ID ?? "",
  READER_URL: source.READER_URL ?? "",
  APP_ENV: source.APP_ENV ?? "development",
  MLC_ORIGIN: source.MLC_ORIGIN ?? "https://mlc.uat.lifeway.com",
  PLAYER_URL: source.PLAYER_URL ?? "https://player.lifeway.com",
  LIVE_EVENTS_URL: source.LIVE_EVENTS_URL ?? "https://live.lifeway.com",
}
